import type { OptionSheetOption } from '@frontend/api-types';
import type { Currency } from '@frontend/duck-tape';
import { formatCurrencyWithCommasAndDecimal, isNil } from '@frontend/duck-tape';
import type { UseListStateHandlers } from '@frontend/react';
import { Button, Card, Checkbox, Image, RenderHTML, Text, XStack, YStack } from '@frontend/web-react';
import { applyClass, concatClasses } from '@frontend/web-utils';

export type OptionSheetCardProps = {
  currency?: Currency;
  disabled?: boolean;
  isSelected: boolean;
  onClick: UseListStateHandlers<OptionSheetOption>['toggle'];
  onClickView: (option: OptionSheetOption) => void;
  option: OptionSheetOption;
};
export const OptionSheetCard = ({
  currency,
  disabled = false,
  isSelected,
  onClick,
  onClickView,
  option,
}: OptionSheetCardProps) => {
  return (
    <Card
      className={concatClasses('flex-1 border-1 bg-white', applyClass(isSelected, 'border-borderSecondary'))}
      disabled={disabled}
      noHoverEffect
      onClick={() => onClick(option, ({ id }) => id)}
      withBorder
      // eslint-disable-next-line tailwindcss/no-arbitrary-value
    >
      <YStack gapY="md">
        <Image aspectRatio="16/9" className="size-full rounded-md" fit="contain" source={option.imageUrls?.[0]} />
        <XStack gapX="sm">
          {disabled ? null : (
            <Checkbox
              checked={isSelected}
              // Resolves warning log
              onChange={() => onClick(option, ({ id }) => id)}
            />
          )}
          <YStack className="gap-y-xs w-full flex-1">
            <XStack gapX="sm" justifyContent="between">
              <Text className="leading-snug" lineClamp={3} type="h5">
                {option.title}
              </Text>
              <XStack>
                <Button label="View" onClick={() => onClickView(option)} size="sm" variant="secondary" />
              </XStack>
            </XStack>
            <RenderHTML className="line-clamp-2" html={option.description} />
            {!isNil(option.price) ? (
              <Text type="h6">{formatCurrencyWithCommasAndDecimal(option.price, currency)}</Text>
            ) : null}
          </YStack>
        </XStack>
      </YStack>
    </Card>
  );
};
